import React from "react";
import { Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTranslation } from "react-i18next";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  BarChartEmptyHorizontically,
  HiddenTypography,
} from "../ChartsLayout/EmptyCharts.jsx";

export default function ExerciseOverview({
  exerciseData,
  exerciseOverview,
  selectedWeek,
}) {
  // console.log("Exercise data in exercise overview: ", exerciseData);
  const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const weekEnds = endOfWeek(selectedWeek, { weekStartsOn: 1 });

  const weekDays = eachDayOfInterval({ start: weekStart, end: weekEnds });

  const {t} = useTranslation("statistics");

  const formattedExerciseData = exerciseData.map((data) => ({
    date: data.date,
    total_hours:
      (data.light === null ? 0 : data.light) +
      (data.moderate === null ? 0 : data.moderate) +
      (data.sedentary === null ? 0 : data.sedentary) +
      (data.vigorous === null ? 0 : data.vigorous),
  }));
  // console.log("Total exercise hours: ", formattedExerciseData);
  const getExerciseTotalHoursForADate = (date) => {
    const dateFormatted = format(date, "yyyy-MM-dd");
    const dayExerciseData = formattedExerciseData.find(
      (data) => data.date === dateFormatted
    );
    return dayExerciseData ? dayExerciseData.total_hours : 0;
  };

  // const weeksMonthsWithData = calculateWeeksAndMonthsWithData(
  //   formattedExerciseData
  // );
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveCharts>
        {({ chartWidth }) => (
          <CustomGridItem>
            <div ref={exerciseOverview}>
              <Typography
                sx={{
                  margin: {
                    xs: "20px 0",
                    sm: "20px 0",
                    md: "0 0 20px 0",
                    lg: "20px 0 0 20px",
                    xl: "20px",
                  },
                  textAlign: "center",
                }}
                variant="h6"
              >
                {t("charts.exercise.durationTitle")}
              </Typography>
              {weekDays.some((day) => getExerciseTotalHoursForADate(day)) ? (
                <>
                  <HiddenTypography />
                  <BarChart
                    yAxis={[
                      {
                        scaleType: "band",
                        data: weekDays.map((day) => format(day, "EEE")),
                      },
                    ]}
                    series={[
                      {
                        data: weekDays.map((day) =>
                          getExerciseTotalHoursForADate(day)
                        ),
                        label: t("series.totalExerciseMinutes"),
                      },
                    ]}
                    layout="horizontal"
                    width={chartWidth}
                    height={300}
                  />
                </>
              ) : (
                <BarChartEmptyHorizontically
                  weekDays={weekDays}
                  chartWidth={chartWidth}
                />
              )}
            </div>
          </CustomGridItem>
        )}
      </ResponsiveCharts>
    </LocalizationProvider>
  );
}
